export const GPL_FOR_DEVS_LICENSE = 'GPL-My-Project-Is-Open-Source';